import { MDBAutocomplete } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import { isFiveNineAccount } from "../../Login";

function PhoneNumberRouting({
  register,
  watch,
  errors,
  setValue,
  callRouting,
  pNumInfo
}) {
  const { t, i18n } = useTranslation();
  const [defaultData, setDefaultData] = useState([]);
  const [displayedValues, setDisplayedValues] = useState([]);
  const [routingValue, setroutingValue] = useState("");
  const[isnineoo , setisnineoo] = useState(false);
  const [isFiveNineAcc , setisFiveNineAcc] = useState(false);

  useEffect(() => {
    setisFiveNineAcc(isFiveNineAccount());
    if (pNumInfo?.assignedto == 911) {
      setisnineoo(true)
    }
    getRoutingDetails();
  }, []);

  const categeory = {
    1: "Auto Attendent",
    2: "User",
    3: "Conference",
    5: "Fax",
    9: "Hunt",
    13: "Fax Group",
    15: "Call Flow",
    16: "Luna",
    // 11: "Connect Conf Bridge",
  };

  const onAdvancedSearch = (value) => {
    const lowercasedValue = value.toLowerCase();
    if (lowercasedValue.trim() !== "") {
      const filteredData = defaultData.filter((item) => {
        const lowercasedTitle = item.name.toLowerCase();
        const isTitleMatch = lowercasedTitle.includes(lowercasedValue);
        const isExtensionsMatch =
          item.extension && item.extension.toString().includes(value);
        const isCategoryMatch =
          item.category && item.category.toLowerCase().includes(value);
        return isTitleMatch || isExtensionsMatch || isCategoryMatch;
      });

      setDisplayedValues(filteredData);
    } else {
      setDisplayedValues([]);
    }
  };

  function handleChange(e, value, category) {
    e?.preventDefault();
    console.log("value :::::::::::::: " + value);
    console.log("module_type :::::::::::::: " + category);
    // let updateObj = {
    //   value: value,
    //   module_type: parseInt(category),
    // };
    // console.log("updateObj ::::::::::: "+JSON.stringify(updateObj));
    setValue("call_routing.module_type", parseInt(category), {
      shouldDirty: true,
    });
    if (parseInt(category) === 11) {
      setValue("call_routing.value", "Connect Conf Bridge", {
        shouldDirty: true,
      });
    } else {
      setValue("call_routing.value", value.toString(), { shouldDirty: true });
    }
  }

  async function getRoutingDetails() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["ph_call_routing"],
      };

      const response = await getMisc(siteid, params);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      } else {
        const data = await response.json();
        if (!data) {
          window.alert(`info with id  not found`);
          Navigate("/");
        }
        console.log("Response phone numbers route Data:", JSON.stringify(data));

        const autos = mapWithModuleType(data?.misc?.ph_call_routing[1], 1);
        const faxgrps = mapWithModuleType(data?.misc?.ph_call_routing[13], 13);
        const callFlows = mapWithModuleType(
          data?.misc?.ph_call_routing[15],
          15
        );
        const users = mapWithModuleType(data?.misc?.ph_call_routing[2], 2);
        const groups = mapWithModuleType(data?.misc?.ph_call_routing[9], 9);
        const conference = mapWithModuleType(data?.misc?.ph_call_routing[3], 3);
        const fax = mapWithModuleType(data?.misc?.ph_call_routing[13], 13);
        const luna = mapWithModuleType(data?.misc?.ph_call_routing[16], 16);


        const connectConf = mapWithModuleType(
          data?.misc?.ph_call_routing[11]
            ? [{ name: data?.misc?.ph_call_routing[11] }]
            : [],
          11
        );

        const mergeWithSortList = [
          ...autos,
          ...callFlows,
          ...faxgrps,
          ...users,
          ...groups,
          ...conference,
          ...fax,
          ...connectConf,
          ...luna,
        ].sort((a, b) => a?.name?.localeCompare(b?.name));

        setDefaultData(mergeWithSortList);
        setDisplayedValues(mergeWithSortList);

        // const token = data?.misc?.generate_newtoken ?? "";
        // setValue("token", token, { shouldDirty: true });
      }
    } catch (error) {
      console.error("[new token] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    if (Object.entries(callRouting).length > 0 && defaultData.length > 0) {
      if (callRouting.module_type === 11 || callRouting.module_type === 4 || callRouting.module_type === 14) {
        setroutingValue(
          (callRouting.value + "" + ((callRouting.module_type === 4) ? " : 911" : ""))
        );
      } else {
        const callRoutingName = defaultData.find(
          (list) => list.value?.toString() === callRouting.value.toString()
        );
        console.log(
          "callRoutingName :::::::::::::::::: " +
          JSON.stringify(callRoutingName)
        );
        if (callRoutingName) {
          setroutingValue(
            `${callRoutingName.name}${callRoutingName.extension ? " : " + callRoutingName.extension : ""}${callRoutingName.module_type && parseInt(callRoutingName.module_type) !== 11 ? " : " + categeory[callRoutingName.module_type] : ""}`
          );
        }
      }
    }
  }, [callRouting, defaultData]);

  const divProps = isnineoo
  ? {
      title: "Caller ID editing is disabled for this profile as it is associated with 911 services.",
      className: "disabled-form cursor-notAllowed",
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
      },
    }
  : {
      className: "phoneselect width-100",
    };
  const mapWithModuleType = (dataArray, moduleType) => {
    return (dataArray ?? []).map((item) => ({
      ...item,
      module_type: moduleType,
    }));
  };
  return (
    <>
      <div className="general-settings">{t("callRouting")}</div>
      <div className={`add-numbermain ${isFiveNineAcc ?"disabled-form cursor-notAllowed" : ""}`}>
        <div className="tel-numbers">
          {t("Assigned To")}
          <br />
          <span className="phrecording text-secondary">
            Calls made to this phone number will be directed here
          </span>
        </div>

        <div className="w-30">
          <div {...divProps}>
            <MDBAutocomplete
              placeholder="Search User or Extension number"
              data={displayedValues}
              disabled = {isFiveNineAcc}
              id="country"
              value={ isnineoo ? "911 Profile" : routingValue}
              onChange={(value) => setroutingValue(value)}
              onSelect={(value) => {
                const selectedItem = displayedValues.find(item => 
                  `${item.name}${item.extension ? " : " + item.extension : ""}${
                    item.module_type && parseInt(item.module_type) !== 11
                      ? " : " + categeory[item.module_type]
                      : ""
                  }` === value
                );
                
                if (selectedItem) {
                  handleChange(null, selectedItem.value, selectedItem.module_type);
                }
              }}
              displayValue={(item) => {
                return `${item.name}${item.extension ? " : " + item.extension : ""}${item.module_type && parseInt(item.module_type) !== 11 ? " : " + categeory[item.module_type] : ""}`;
              }}
              itemContent={(result) => (
                <div
                  onClick={(e) =>
                    handleChange(e, result.value, result.module_type)
                  }
                >{`${result.name}${result.extension ? " : " + result.extension : ""}${result.module_type && parseInt(result.module_type) !== 11 ? " : " + categeory[result.module_type] : ""}`}</div>
              )}
              onSearch={onAdvancedSearch}
            />
          </div>
        </div>
      </div>
      <div className="routing-border mb-4"></div>
    </>
  );
}

export default PhoneNumberRouting;
